<shortcut-menu [subscription]="subscription()">
  <wireless-tickets-item [tickets]="tickets()" />
  <wireless-suppliers-item [suppliers]="suppliers()" />
  <service-documentation-item [url]="serviceDocumentationUrl" />
</shortcut-menu>
